import { useState } from 'react';
import { useAuthStore } from '../../stores/authStore';
import { createCheckoutSession } from '../../services/payments/checkout';
import { STRIPE_CONFIG } from '../../config/stripe/constants';
import { PaymentState } from '../../config/stripe/types';

export const useStripePayment = () => {
  const [state, setState] = useState<PaymentState>({
    loading: false,
    error: null
  });
  const { user } = useAuthStore();

  const initiateCheckout = async (priceId: string) => {
    if (!user) {
      setState(prev => ({ ...prev, error: 'You must be logged in to make a purchase' }));
      return;
    }

    try {
      setState(prev => ({ ...prev, loading: true, error: null }));

      const session = await createCheckoutSession(priceId, {
        successUrl: STRIPE_CONFIG.successUrl,
        cancelUrl: STRIPE_CONFIG.cancelUrl
      });

      window.location.assign(session.url);
    } catch (err) {
      console.error('Payment error:', err);
      setState(prev => ({
        ...prev,
        error: 'Failed to initiate payment. Please try again.'
      }));
    } finally {
      setState(prev => ({ ...prev, loading: false }));
    }
  };

  return {
    initiateCheckout,
    loading: state.loading,
    error: state.error
  };
};